import { useVeltClient, VeltRecorderTool, VeltRecorderControlPanel, VeltRecorderPlayer, VeltCommentTool } from '@veltdev/react';
import { useEffect, useState } from 'react';
import "./Roadmap.css"
import YourAuthComponent from './YourAuthComponent';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  const [recordedData, setRecordedData] = useState([]);
  


  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('unique-document-id-product-board-demo-roadmap');
      let commentElement = client.getCommentElement()
      commentElement.disablePopoverMode();
    }
  }, [client]);

  return (<>
    <meta
      httpEquiv="Content-Security-Policy"
      content="base-uri optimize.google.com; object-src 'none'; script-src 'self' cdn.productboard.com blob: *.stripe.com use.typekit.net *.jquery.com unpkg.com/es6-promise@4.1.0/dist/es6-promise.min.js unpkg.com/whatwg-fetch@2.0.3/fetch.js ana-api.productboard.com ana-cdn.productboard.com *.intercom.io *.intercomcdn.com cdn.sprig.com google-analytics.com www.google-analytics.com www.googletagmanager.com www.googleadservices.com www.google.com optimize.google.com *.doubleclick.net cdn.heapanalytics.com heapanalytics.com cdn.mxpnl.com connect.facebook.net *.wistia.com *.wistia.net src.litix.io/core/2/mux.js *.hotjar.com *.ads-twitter.com *.licdn.com *.linkedin.com *.twitter.com d3pkntwtp2ukl5.cloudfront.net/uba.js t.unbounce.com pi.pardot.com *.clearbit.com clearbitjs.com *.marketo.net *.marketo.com *.productboard.com cdn.madkudu.com ajax.cloudflare.com/cdn-cgi/scripts/7089c43e/cloudflare-static/rocket-loader.min.js *.zdassets.com *.6sc.co *.dopt.com 'nonce-ANg67q0VBCLYaERjUEmGMQ==' 'nonce-sZvTUdJpCqzmaI2rkg6whQ==' 'nonce-NVfokFmRHbT+b4jz/xz4WQ==' 'nonce-qBBV+Yjg4FDFAf6nZTpAoA==' 'nonce-3FJAd2H9/8R1MOSO7z+foA==' 'nonce-Qy5kBdfmSCD/BUPlxQFvJw==' 'nonce-tby/GEyTSm3c7XvnFvx4IA==' 'strict-dynamic'; style-src 'self' 'unsafe-inline' cdnjs.cloudflare.com use.typekit.net p.typekit.net cdn.productboard.com heapanalytics.com maxcdn.bootstrapcdn.com *.marketo.com info.productboard.com optimize.google.com; default-src 'self'; font-src 'self' cdn.productboard.com data: use.typekit.net fonts.typekit.net *.intercomcdn.com *.wistia.com heapanalytics.com maxcdn.bootstrapcdn.com; frame-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; child-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; form-action https://intercom.help https://api-iam.intercom.io *.productboard.com *.productboard.info; img-src * data: blob: heapanalytics.com https://js.intercomcdn.com https://static.intercomassets.com https://downloads.intercomcdn.com https://downloads.intercomcdn.eu https://downloads.au.intercomcdn.com https://uploads.intercomusercontent.com https://gifs.intercomcdn.com  https://video-messages.intercomcdn.com https://messenger-apps.intercom.io https://messenger-apps.eu.intercom.io https://messenger-apps.au.intercom.io https://*.intercom-attachments-1.com https://*.intercom-attachments.eu https://*.au.intercom-attachments.com https://*.intercom-attachments-2.com https://*.intercom-attachments-3.com https://*.intercom-attachments-4.com https://*.intercom-attachments-5.com https://*.intercom-attachments-6.com https://*.intercom-attachments-7.com https://*.intercom-attachments-8.com https://*.intercom-attachments-9.com https://static.intercomassets.eu https://static.au.intercomassets.com; connect-src 'self' 'self' blob: cdn.productboard.com nucleus.productboard.net *.pusher.com wss://ws.pusherapp.com:443 wss://ws.pusherapp.com wss://ws-eu.pusherapp.com:443 wss://ws-eu.pusherapp.com wss://ws-eu.pusher.com wss://ws-mt1.pusher.com ana-api.productboard.com *.segment.com api.intercom.io api.au.intercom.io api.eu.intercom.io api-iam.intercom.io api-iam.eu.intercom.io api-iam.au.intercom.io  api-ping.intercom.io   nexus-websocket-a.intercom.io wss://nexus-websocket-a.intercom.io nexus-websocket-b.intercom.io wss://nexus-websocket-b.intercom.io nexus-europe-websocket.intercom.io  wss://nexus-europe-websocket.intercom.io  nexus-australia-websocket.intercom.io wss://nexus-australia-websocket.intercom.io  uploads.intercomcdn.com uploads.intercomcdn.eu  uploads.au.intercomcdn.com  uploads.intercomusercontent.com  *.intercomcdn.com api.sprig.com vc.hotjar.io *.typekit.net api.mixpanel.com *.wistia.com *.wistia.net *.facebook.com api.trello.com embedwistia-a.akamaihd.net heapanalytics.com *.googlesyndication.com *.google.com www.google-analytics.com *.litix.io *.clearbit.com *.mktoresp.com *.launchdarkly.com api.honeycomb.io *.hotjar.com wss://*.hotjar.com *.ingest.sentry.io *.doubleclick.net *.browser-intake-datadoghq.com https://api.amplitude.com https://api2.amplitude.com *.zdassets.com widget-mediator.zopim.com wss://widget-mediator.zopim.com productboard.zendesk.com *.6sc.co *.adnxs.com *.loom.com app.satismeter.com *.dopt.com wss://*.dopt.com; media-src 'self' data: blob: *.intercomcdn.com embedwistia-a.akamaihd.net *.wistia.com cdn.productboard.com nucleus.productboard.net *.zdassets.com cdn.loom.com; worker-src 'self' blob:"
    />
    <meta charSet="utf-8" />
    <meta name="referrer" content="origin" />
    <title>Feature launch roadmap (sample) | Productboard</title>
    <meta
      name="description"
      content="Get the right products to market, faster."
    />
    <meta property="og:title" content="Productboard" />
    <meta
      property="og:description"
      content="Get the right products to market, faster."
    />
    <meta name="revision" content="f38081175c15cbc50246e3ccf9385cec74109b55" />
    <section id="react" className="is-viewer">
      <div className="animated-componentstyled__fade-sc-12t1a22-0 hkNeWR appear-done enter-done">
        <div className="application-content__ApplicationContainer-sc-1k5swnc-0 fRmFgP">
          <div className="application-content__Application-sc-1k5swnc-1 gaQKLZ">
            <div className="main-menu-expand-button__Container-sc-a3nm2x-0 lfcfkH">
              <div className="box__StyledBox-sc-b30x7m-0 huKWQq">
                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                  <button
                    type="button"
                    aria-label="Collapse menu"
                    data-nc="true"
                    data-testid="Header-MenuButton"
                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                  >
                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                      <svg
                        height="16px"
                        width="16px"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="CollapseNavigationIcon"
                        className="sc-11y93t1-0 dqXaRM ui-icon"
                      >
                        <path
                          d="M8 2h6v2H8V2ZM14 12H8v2h6v-2ZM14 7H8v2h6V7Z"
                          fill="currentColor"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="m.317 7.221 3.831-3.897a1.07 1.07 0 0 1 1.533 0c.423.43.423 1.128 0 1.558L2.616 8l3.065 3.118a1.117 1.117 0 0 1 0 1.56c-.423.43-1.11.43-1.533 0L.318 8.78a1.116 1.116 0 0 1 0-1.559Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </button>
                </span>
              </div>
            </div>
            <header width={256} className="main-menu__Header-sc-1px38at-0 ddVgTE">
              <div
                style={{
                  position: "relative",
                  userSelect: "auto",
                  width: 256,
                  height: "100%",
                  maxWidth: 480,
                  minWidth: 240,
                  boxSizing: "border-box",
                  flexShrink: 0
                }}
              >
                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jNTZsy">
                  <div
                    data-testid="Account-Menu"
                    className="header__Trigger-sc-msz0fa-1 jQTgDt"
                  >
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 eqxftF">
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 gCQyQp">
                        <svg
                          height="20px"
                          viewBox="0 0 162 108"
                          data-testid="AppHeader-Logo"
                          data-nc="true"
                        >
                          <path
                            fill="#0071E1"
                            d="M108.001 0L162 54l-54.001 54-53.996-54L108 0z"
                          />
                          <path
                            fill="#FFC600"
                            d="M107.997 0L53.999 54 0 0h107.997z"
                          />
                          <path
                            fill="#F84136"
                            d="M53.999 54l53.998 54H0l53.999-54z"
                          />
                        </svg>
                      </div>
                      <div
                        data-nc="true"
                        className="heading__StyledHeading-sc-114dp0l-0 XDuDU"
                      >
                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                          <span className="header__HeadingWrapper-sc-msz0fa-0 gcTzuh">
                            <YourAuthComponent/>
                          </span>
                        </span>
                      </div>
                      <svg
                        height="16px"
                        width="16px"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="ArrowCaretIcon"
                        className="sc-11y93t1-0 xIpMQ ui-icon"
                      >
                        <path
                          fill="currentColor"
                          fillRule="evenodd"
                          d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jaLSkS">
                  <div className="quickfind__Container-sc-b1ll48-0 eZSrsz">
                    <div className="menu-item__Item-sc-18xys5o-1 jwMyEu">
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="SearchIcon"
                          className="sc-11y93t1-0 kqDcRj ui-icon"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNrzLm">
                          <div className="menu-item__Label-sc-18xys5o-0 fTajIn">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                  <span
                                    data-testid="Quickfind-MenuItem"
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 kURyuR"
                                  >
                                    Find board
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-testid="Quickfind-Modal" />
                  </div>
                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 gyXsuf">
                    <button
                      type="button"
                      aria-label="Notifications"
                      data-nc="true"
                      data-testid="NotificationCenter-Button"
                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                    >
                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                        <div className="sc-1bp6zuu-0 dqbDkO">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="NotificationIcon"
                            className="sc-11y93t1-0 xIpMQ ui-icon"
                          >
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M15 11.999h-1V8c0-3.589-3.725-8-6-8S2 4.411 2 8v3.999H1A1 1 0 0 0 1 14h4c0 1.104 1.343 2 3 2 1.656 0 3-.896 3-2h4a1 1 0 0 0 0-2.001zm-11 0v-3C4 5.208 6.987 2 8 2s3.999 3.333 3.999 6.999v3H4z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </div>
                    </button>
                  </span>
                </div>
                <div
                  data-testid="main-menu-scroll-container"
                  className="main-menu__ScrollContainer-sc-1px38at-1 cEGlbj"
                >
                  <div className="scroll-shadow__StyledScrollShadow-sc-19nlq98-0 dWqUOp main-menu___StyledScrollShadow-sc-1px38at-4 iQrqyW">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jFTdor main-menu___StyledFlex-sc-1px38at-5 ihhPDO">
                      <div className="main-menu__ScrollContainerContent-sc-1px38at-2 ewMtvs">
                        <div
                          className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                          data-testid="StaticMenu"
                        >
                          <div className="static-menu-itemstyled__HomeStaticItemContainer-sc-jveuem-0 emwIkj">
                            <a
                              data-testid="StaticMenuItem"
                              tabIndex={0}
                              data-nc="true"
                              className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                              href="/home"
                            >
                              <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                        <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                          <svg
                                            height="16px"
                                            width="16px"
                                            viewBox="0 0 16 16"
                                            role="img"
                                            aria-label="HomeIcon"
                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M6 10.03c-.6 0-1 .4-1 1v3H3v-7.5l5-4.2 5 4.2v7.5h-2v-3c0-.6-.4-1-1-1H6ZM10 16h4c.6 0 1-.4 1-1V6.03c0-.3-.1-.6-.4-.8l-6-5c-.4-.3-.9-.3-1.3 0l-6 5c-.2.2-.3.5-.3.8V15c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-2.97h2V15c0 .6.4 1 1 1Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                      <div
                                        data-nc="true"
                                        className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                      >
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                              <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                  Home
                                                </div>
                                              </div>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/teamspaces/all"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="AllTeamspacesIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                All teamspaces
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                          <div
                            data-testid="MainMenuSection-Favorites"
                            className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                          >
                            <div
                              className="a6XhA2vk2hktu_NcQWh7"
                              role="heading"
                              data-testid="Group-Heading"
                            >
                              Favorites
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                              <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="ChevronRightIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          display="flex"
                          className="box__StyledBox-sc-b30x7m-0 latrRT"
                        >
                          <span
                            data-nc="true"
                            className="textstyled__StyledText-sc-cx1866-0 dOIxr"
                          >
                            No boards yet
                          </span>
                        </div>
                        <div className="navigation-sections__Wrapper-sc-ng4kon-0 evgVDh">
                          <div className="navigation-teamspace-coachmark__AttachableCoachmarkPlaceholder-sc-4bu7ey-0 dNoCXR" />
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                            <div
                              data-testid="MainMenuSection-Teamspaces"
                              className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                            >
                              <div
                                className="a6XhA2vk2hktu_NcQWh7"
                                role="heading"
                                data-testid="Group-Heading"
                              >
                                Teamspaces
                              </div>
                              <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                                <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ChevronRightIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 hqdVxL">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                <a href="/teamspaces/all">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      type="button"
                                      aria-label="All teamspaces"
                                      data-nc="true"
                                      data-testid="all-team-spaces-button"
                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                    >
                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="AllTeamspacesIcon"
                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                        >
                                          <path
                                            d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </button>
                                  </span>
                                </a>
                              </div>
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      type="button"
                                      aria-label="Create a new teamspace"
                                      data-nc="true"
                                      data-testid="create-teamspace-section-button"
                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                    >
                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="PlusCircleIcon"
                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                        >
                                          <path
                                            fill="currentColor"
                                            fillRule="evenodd"
                                            d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            display="inherit"
                            className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                          >
                            <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                              <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                                <ul
                                  data-testid="TeamspacesNavigationSection"
                                  role="listbox"
                                  className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                                >
                                  <li data-spacer="true" style={{ height: 4 }} />
                                  <li
                                    data-index={0}
                                    data-id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                    role="presentation"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="TeamspaceItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="TeamspaceIcon"
                                                      className="sc-11y93t1-0 cRyrkY ui-icon"
                                                    >
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                                        fill=""
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            General
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <div
                                                      display="flex"
                                                      className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                    >
                                                      <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                          <button
                                                            type="button"
                                                            aria-label="Show more"
                                                            data-nc="true"
                                                            className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                          >
                                                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                              <svg
                                                                height="16px"
                                                                width="16px"
                                                                viewBox="0 0 16 16"
                                                                role="img"
                                                                aria-label="DotsIcon"
                                                                className="sc-11y93t1-0 dqXaRM ui-icon"
                                                              >
                                                                <path
                                                                  fill="currentColor"
                                                                  fillRule="evenodd"
                                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            </div>
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="add-Generalboard-left-nav"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={1}
                                    data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="FolderItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="TeamspaceFolderOpenIcon"
                                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                                    >
                                                      <path
                                                        fill=""
                                                        d="M2 2h11v5H2z"
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                        fill="currentColor"
                                                      />
                                                      <path
                                                        d="M3 6h12l-2 8H1l2-8Z"
                                                        fill=""
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feature boards
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <div
                                                      display="flex"
                                                      className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                    >
                                                      <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                          <button
                                                            type="button"
                                                            aria-label="Show more"
                                                            data-nc="true"
                                                            data-testid="Folder-ContextMenu"
                                                            className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                          >
                                                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                              <svg
                                                                height="16px"
                                                                width="16px"
                                                                viewBox="0 0 16 16"
                                                                role="img"
                                                                aria-label="DotsIcon"
                                                                className="sc-11y93t1-0 dqXaRM ui-icon"
                                                              >
                                                                <path
                                                                  fill="currentColor"
                                                                  fillRule="evenodd"
                                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            </div>
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="add-Feature boardsboard-left-nav"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={2}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/feature-board/7450405-feature-planning-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="FeaturesBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feature planning
                                                            (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                  <li
                                    data-index={3}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/feature-board/7450406-feature-prioritization-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="FeaturesBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feature prioritization
                                                            (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                  <li
                                    data-index={4}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NzkwNTBiOTMtMDEwNi00YzI1LWFhZjUtZGY5ZTVhOWFkNWY1"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="BoardItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="FeaturesBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feedback-driven
                                                            prioritization
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                    <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                      <svg
                                                        height="12px"
                                                        width="12px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="UpgradeIcon"
                                                        className="sc-11y93t1-0 gwBFtq ui-icon"
                                                      >
                                                        <path
                                                          d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                      <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                        <span
                                                          data-nc="true"
                                                          className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                        >
                                                          Pro
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={5}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NDBjYjViYTMtNTE0MC00ZDdmLTllZTktNGFhNTNmMDkwMGU2"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="BoardItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="FeaturesBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Objective-driven
                                                            prioritization
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                    <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                      <svg
                                                        height="12px"
                                                        width="12px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="UpgradeIcon"
                                                        className="sc-11y93t1-0 gwBFtq ui-icon"
                                                      >
                                                        <path
                                                          d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                      <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                        <span
                                                          data-nc="true"
                                                          className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                        >
                                                          Enterprise
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={6}
                                    data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="FolderItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="TeamspaceFolderOpenIcon"
                                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                                    >
                                                      <path
                                                        fill=""
                                                        d="M2 2h11v5H2z"
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                        fill="currentColor"
                                                      />
                                                      <path
                                                        d="M3 6h12l-2 8H1l2-8Z"
                                                        fill=""
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Roadmaps
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <div
                                                      display="flex"
                                                      className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                    >
                                                      <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                          <button
                                                            type="button"
                                                            aria-label="Show more"
                                                            data-nc="true"
                                                            data-testid="Folder-ContextMenu"
                                                            className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                          >
                                                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                              <svg
                                                                height="16px"
                                                                width="16px"
                                                                viewBox="0 0 16 16"
                                                                role="img"
                                                                aria-label="DotsIcon"
                                                                className="sc-11y93t1-0 dqXaRM ui-icon"
                                                              >
                                                                <path
                                                                  fill="currentColor"
                                                                  fillRule="evenodd"
                                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            </div>
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="add-Roadmapsboard-left-nav"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={7}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/roadmap/7450412-feature-launch-roadmap-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 krOJcX">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="RoadmapBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feature launch roadmap
                                                            (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                  <li
                                    data-index={8}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/roadmap/7450409-kanban-roadmap-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="RoadmapBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Kanban roadmap
                                                            (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                  <li
                                    data-index={9}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/roadmap/7450410-sprint-roadmap-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="RoadmapBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Sprint roadmap
                                                            (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                  <li
                                    data-index={10}
                                    data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-0"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <a
                                        data-testid="BoardItem"
                                        tabIndex={0}
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                        href="/roadmap/7450411-features-timeline-roadmap-sample"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="RoadmapBoardIcon"
                                                      className="sc-11y93t1-0 dEkNOy ui-icon"
                                                    >
                                                      <rect
                                                        x={1}
                                                        y={1}
                                                        width={14}
                                                        height={14}
                                                        rx={3}
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Features timeline
                                                            roadmap (sample)
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="Board-ContextMenu"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </li>
                                </ul>
                                <div
                                  data-testid="ListHeadless-KeyboardAnchor"
                                  tabIndex={0}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                            <div
                              data-testid="MainMenuSection-Personal"
                              className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                            >
                              <div
                                className="a6XhA2vk2hktu_NcQWh7"
                                role="heading"
                                data-testid="Group-Heading"
                              >
                                Personal
                              </div>
                              <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                                <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ChevronRightIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  aria-label="Show more"
                                  data-nc="true"
                                  data-testid="add-Personalboard-left-nav"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="PlusIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                          </div>
                          <div
                            display="inherit"
                            className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                          >
                            <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                              <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                                <ul
                                  data-testid="PersonalNavigationSection"
                                  role="listbox"
                                  className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                                >
                                  <li data-spacer="true" style={{ height: 4 }} />
                                  <li
                                    data-index={0}
                                    data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-1"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="FolderItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="TeamspaceFolderIcon"
                                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                                    >
                                                      <path
                                                        fill=""
                                                        d="M1 3h14v11H1z"
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Feature boards
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <div
                                                      display="flex"
                                                      className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                    >
                                                      <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                          <button
                                                            type="button"
                                                            aria-label="Show more"
                                                            data-nc="true"
                                                            data-testid="Folder-ContextMenu"
                                                            className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                          >
                                                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                              <svg
                                                                height="16px"
                                                                width="16px"
                                                                viewBox="0 0 16 16"
                                                                role="img"
                                                                aria-label="DotsIcon"
                                                                className="sc-11y93t1-0 dqXaRM ui-icon"
                                                              >
                                                                <path
                                                                  fill="currentColor"
                                                                  fillRule="evenodd"
                                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            </div>
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="add-Feature boardsboard-left-nav"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li
                                    data-index={1}
                                    data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                    role="option"
                                    className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                  >
                                    <div
                                      role="button"
                                      aria-roledescription="sortable"
                                      aria-describedby="DndDescribedBy-1"
                                      className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                    >
                                      <div
                                        tabIndex={0}
                                        data-testid="FolderItem"
                                        data-nc="true"
                                        className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                      >
                                        <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                  <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                    <svg
                                                      height="16px"
                                                      width="16px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="TeamspaceFolderIcon"
                                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                                    >
                                                      <path
                                                        fill=""
                                                        d="M1 3h14v11H1z"
                                                      />
                                                      <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                        fill="currentColor"
                                                      />
                                                    </svg>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                                className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                              >
                                                <div
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                                >
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                          <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                            Roadmaps
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                  <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                    <div
                                                      display="flex"
                                                      className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                    >
                                                      <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                          <button
                                                            type="button"
                                                            aria-label="Show more"
                                                            data-nc="true"
                                                            data-testid="Folder-ContextMenu"
                                                            className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                          >
                                                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                              <svg
                                                                height="16px"
                                                                width="16px"
                                                                viewBox="0 0 16 16"
                                                                role="img"
                                                                aria-label="DotsIcon"
                                                                className="sc-11y93t1-0 dqXaRM ui-icon"
                                                              >
                                                                <path
                                                                  fill="currentColor"
                                                                  fillRule="evenodd"
                                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            </div>
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="add-Roadmapsboard-left-nav"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                  </span>
                                                  <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                                <div
                                  data-testid="ListHeadless-KeyboardAnchor"
                                  tabIndex={0}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                          data-testid="DataMenu"
                        >
                          <div className="box__StyledBox-sc-b30x7m-0 kQacQF">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                              <div
                                data-testid="MainMenuSection-Data"
                                className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                              >
                                <div
                                  className="a6XhA2vk2hktu_NcQWh7"
                                  role="heading"
                                  data-testid="Group-Heading"
                                >
                                  Data
                                </div>
                                <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                                  <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="ChevronRightIcon"
                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/data/drivers-scores"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="DriverIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            fill="currentColor"
                                            fillRule="evenodd"
                                            d="M14 0H2c-.553 0-1 .447-1 .999V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V.999A1 1 0 0 0 14 0zM5 14H3v-2h2v2zm0-3.001H3V9h2v1.999zM5 8H3V6h2v2zm4 6H7v-2h2v2zm0-3.001H7V9h2v1.999zM9 8H7V6h2v2zm4 6h-2v-2h2v2zm0-3.001h-2V9h2v1.999zM13 8h-2V6h2v2zm0-4H3V2h10v2z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Drivers &amp; Scores
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/data/releases"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="ReleaseIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <g fill="currentColor">
                                            <path d="M0 15a1 1 0 1 0 2 0V1a1 1 0 0 0-2 0v14z" />
                                            <path
                                              fillRule="evenodd"
                                              d="M15.793 1.588A.95.95 0 0 0 16 1c0-.552-.484-1-1.08-1H5.16C3.967 0 3 .895 3 2v7c0 1.105.967 2 2.16 2h9.76c.228 0 .45-.067.635-.191.483-.325.59-.95.238-1.397L13 5.5l2.793-3.912zM10.543 5.5l2.5-3.5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.042l-2.5-3.5z"
                                              clipRule="evenodd"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Releases
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/data/tasks"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="TaskIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            fill="currentColor"
                                            fillRule="evenodd"
                                            d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 0 1 8 2c1.809 0 3.426.803 4.525 2.068-.148.05-.289.125-.408.237L7.698 8.478 5.878 6.76a1.15 1.15 0 0 0-1.56 0 1 1 0 0 0 0 1.473l2.6 2.454a1.151 1.151 0 0 0 1.56 0l5.12-4.834C13.854 6.52 14 7.242 14 8a6 6 0 0 1-6 6z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Tasks
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/data/default-fields"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="DotsIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            fill="currentColor"
                                            fillRule="evenodd"
                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Default Fields
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="main-menu__ScrollContainerFiller-sc-1px38at-3 jDUtYe" />
                      <div className="trial-progress__TrialProgressFooter-sc-1921okl-0 emEYZt">
                        <div className="expanded-trial-period__ExpandedWrapper-sc-hvxksn-0 guvfZL">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 dGHbcT">
                            <div>
                              <span
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 byMfUs"
                              >
                                14
                              </span>{" "}
                              <span
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 eheNCz"
                              >
                                days left
                              </span>
                            </div>
                            <button
                              type="button"
                              data-nc="true"
                              className="button-primitive__StyledButton-sc-1guvopt-0 fkgSPA"
                            >
                              <span className="button-primitive__StyledContent-sc-1guvopt-1 jnjmlp">
                                <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                  Buy now
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                        <button
                          data-nc="true"
                          className="linkstyled__Link-sc-14qwv7c-0 fkgqsY"
                        >
                          <span className="linkstyled__Text-sc-14qwv7c-2 bdTmqZ">
                            Try different plan
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      userSelect: "none",
                      width: 7,
                      height: "100%",
                      top: 0,
                      cursor: "col-resize",
                      right: "-3px"
                    }}
                  >
                    <div
                      direction="vertical"
                      className="resize-handle__HandleContainer-sc-1idsfk7-1 hRNShL"
                    >
                      <div
                        direction="vertical"
                        className="resize-handle__HandleDivider-sc-1idsfk7-0 wxlNu"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="WRgq_U97OawHo6EQhRRQ">
              <div className="animated-componentstyled__fade-sc-12t1a22-0 ecvVSH Mg_bVvVOl9HZYGa9blNT appear-done enter-done" />
            </div>
            <div data-hotkeys-layer="true" tabIndex={-1} />
            <div
              data-hotkeys-layer="true"
              tabIndex={-1}
              className="oPyCBxyA5atdQyPwGQZM"
              style={{}}
            >
              <div className="flexstyled__StyledFlex-sc-lvlevv-0 iCCEGT">
                <div className="header-container__Container-sc-1eys2lk-0 TnoVX">
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 hUBHRF">
                    <div className="header-primary__LeftContainer-sc-179e15q-0 ctEHxx">
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jSxgqC">
                        <div className="header-primary__SelectableTitle-sc-179e15q-1 dHnedO">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 cquxeH">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iEFJYo">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 SgsON">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="TeamspaceIcon"
                                  className="sc-11y93t1-0 cRyrkY ui-icon"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                    fill=""
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                    fill="currentColor"
                                  />
                                </svg>
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                    <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                      <h1
                                        data-nc="true"
                                        data-testid="header-name"
                                        className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                      >
                                        General
                                      </h1>
                                    </div>
                                  </div>
                                </span>
                              </div>
                              <span
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                              >
                                /
                              </span>
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fBNEaG">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                    <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                      <h1
                                        data-nc="true"
                                        data-testid="header-name"
                                        className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                      >
                                        Roadmaps
                                      </h1>
                                    </div>
                                  </div>
                                </span>
                              </div>
                              <span
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                              >
                                /
                              </span>
                            </div>
                            <div className="renamable-title__Container-sc-1our1fr-0 ccjVcs">
                              <div className="editable-textstyled__StyledEditableText-sc-1r26pyp-0 hEcAMv">
                                <div
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 hWldxC"
                                >
                                  <div className="editable-textstyled__StyledHiddenLabel-sc-1r26pyp-1 cOlZlT">
                                    <div className="editable-textstyled__StyledHiddenLabelInner-sc-1r26pyp-2 kCXWkG">
                                      <div className="truncate__TruncateWrapper-sc-11ftd2c-1 caVNcG">
                                        Feature launch roadmap (sample)
                                      </div>
                                    </div>
                                  </div>
                                  <div className="editable-textstyled__StyledAbsolute-sc-1r26pyp-3 cOwQwL">
                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                      <input
                                        data-testid="EditableBoardTitle"
                                        className="editable-textstyled__StyledEditableTextInput-sc-1r26pyp-4 iWIqyJ"
                                        defaultValue="Feature launch roadmap (sample)"
                                        style={{ width: 209 }}
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="favorite-container__Container-sc-19nndzy-0 cGskpP">
                          <div className="favorite-container__FavoriteContainerStyled-sc-19nndzy-1 fcwIws">
                            <div>
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="StarIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <g clipPath="url(#Star_svg__a)">
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="m8.467 11.11 2.531 1.331-.482-2.82a1 1 0 0 1 .287-.885l2.048-1.998-2.83-.41a.996.996 0 0 1-.753-.548L8 3.214 6.734 5.78a1 1 0 0 1-.753.547l-2.831.411 2.049 1.998a1 1 0 0 1 .287.885l-.483 2.82 2.532-1.33a.998.998 0 0 1 .932 0zm3.393 4.044L8 13.125l-3.86 2.03c-.726.386-1.591-.236-1.45-1.055l.737-4.299L.303 6.757a1 1 0 0 1 .555-1.706l4.316-.627L7.104.512c.337-.683 1.458-.683 1.794 0l1.93 3.911 4.317.627a1.001 1.001 0 0 1 .555 1.706l-3.124 3.045.736 4.3c.142.822-.726 1.435-1.451 1.053z"
                                      clipRule="evenodd"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="Star_svg__a">
                                      <path fill="#fff" d="M0 0h16v16H0z" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 wctrz">

                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                        <VeltCommentTool/>
                      
                      </span>
                      <div
                        data-search-field-loading="false"
                        data-nc="true"
                        className="text-field-primitivestyled__Wrapper-sc-1ndan3b-0 fplKzA"
                      >
                        <div className="text-field-primitivestyled__Field-sc-1ndan3b-3 gHGzqM">
                          <span className="text-field-primitivestyled__IconWrapper-sc-1ndan3b-1 dUAWyH">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNNPTr">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="SearchIcon"
                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                data-testid="Header-SearcField-SearchIcon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </span>
                          <input
                            type="search"
                            placeholder="Search..."
                            autoComplete="off"
                            data-testid="Header-SearcField"
                            data-search-field-loading="false"
                            className="text-field-primitivestyled__StyledTextField-sc-1ndan3b-6 gbzXRE"
                            defaultValue=""
                          />
                        </div>
                      </div>
                      <div style={{}}>
                        <div
                          data-testid="view-history-button"
                          className="sc-19b603x-0 lbmqiu"
                        >
                          <div className="avatar-groupstyled__Container-sc-1mr3229-0 fOKNgP">
                            <div className="avatar-groupstyled__MaskWrapper-sc-1mr3229-3 hEoVvB">
                              <svg>
                                <defs>
                                  <clipPath id="maskUser16">
                                    <path d="M1.36412 18C4.70029 16.3793 7 12.9582 7 9C7 5.0418 4.70029 1.62072 1.36412 0H18V18H1.36412Z" />
                                  </clipPath>
                                  <clipPath id="maskUser20">
                                    <path d="M3.93137 22C7.57795 19.6974 9.99999 15.6315 9.99999 11C9.99999 6.36847 7.57795 2.30263 3.93137 0H22V22H3.93137Z" />
                                  </clipPath>
                                  <clipPath id="maskUser24">
                                    <path d="M2.48834 26C6.97828 23.4081 9.99999 18.5569 9.99999 13C9.99999 7.44307 6.97828 2.59191 2.48834 0H26V26H2.48834Z" />
                                  </clipPath>
                                  <clipPath id="maskUser28">
                                    <path d="M1.00711 30C6.359 27.1371 10 21.4938 10 15C10 8.50623 6.359 2.86286 1.00711 0H30V30H1.00711Z" />
                                  </clipPath>
                                  <clipPath id="maskUser36">
                                    <path d="M0 37.9791C7.09484 34.6087 12 27.3772 12 19C12 10.6228 7.09484 3.39129 0 0.0208935L0 0H38V38H0V37.9791Z" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div
                              data-testid="view-history"
                              className="avatar-groupstyled__Group-sc-1mr3229-1 bhhZYF"
                            >
                              <div className="avatar-groupstyled__Wrapper-sc-1mr3229-2 kxKBgx">
                                <div
                                  data-nc="true"
                                  className="avatar-primitivestyled__Container-sc-1bx7ono-0 hwhhyy"
                                >
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <div className="avatar-primitivestyled__Wrapper-sc-1bx7ono-1 hjdAVk">
                                      <div className="avatar-primitivestyled__Mask-sc-1bx7ono-5 cigJeP">
                                        <div className="avatar-primitivestyled__Content-sc-1bx7ono-2 btKcPp">
                                          <div className="avatar-primitivestyled__ImageWrapper-sc-1bx7ono-4 gnyQMd">
                                            <img
                                              src="https://www.gravatar.com/avatar/499078fe3cabdc97d9bd855634a77a2e?s=52&d=404"
                                              alt="Ben Lin avatar"
                                              loading="lazy"
                                              decoding="async"
                                              height="100%"
                                              width="100%"
                                              data-nc="true"
                                              className="image__ResponsiveImage-sc-4gu1yy-0 bgZoMb"
                                            />
                                          </div>
                                          <div className="avatar-initialsstyled__Initials-sc-mzeca6-0 hxLfBU">
                                            <span
                                              data-nc="true"
                                              className="textstyled__StyledText-sc-cx1866-0 eALGil"
                                            >
                                              BL
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </div>
                              </div>
                              <div className="avatar-groupstyled__Wrapper-sc-1mr3229-2 fyoWoK">
                                <div
                                  data-nc="true"
                                  className="avatar-primitivestyled__Container-sc-1bx7ono-0 hwhhyy"
                                >
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <div className="avatar-primitivestyled__Wrapper-sc-1bx7ono-1 dAlVxL">
                                      <div className="avatar-primitivestyled__Mask-sc-1bx7ono-5 cigJeP">
                                        <div className="avatar-primitivestyled__Content-sc-1bx7ono-2 gjwPrT">
                                          <div className="avatar-primitivestyled__ImageWrapper-sc-1bx7ono-4 gnyQMd">
                                            <img
                                              src="https://www.gravatar.com/avatar/c8836721209a210a9e10969bbfa9bec1?s=52&d=404"
                                              alt="Rakesh Goyal avatar"
                                              loading="lazy"
                                              decoding="async"
                                              height="100%"
                                              width="100%"
                                              data-nc="true"
                                              className="image__ResponsiveImage-sc-4gu1yy-0 bgZoMb"
                                            />
                                          </div>
                                          <div className="avatar-initialsstyled__Initials-sc-mzeca6-0 hxLfBU">
                                            <span
                                              data-nc="true"
                                              className="textstyled__StyledText-sc-cx1866-0 eALGil"
                                            >
                                              RG
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        data-nc="true"
                        data-testid="Header-ShareButton"
                        className="button-primitive__StyledButton-sc-1guvopt-0 dcewKt"
                      >
                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="ShareIcon"
                            className="sc-11y93t1-0 dqXaRM ui-icon"
                          >
                            <path
                              d="M1 16h14c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-3v2h2v7H2V7h2V5H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1Z"
                              fill="currentColor"
                            />
                            <path
                              d="M7.61 11a.6.6 0 0 1-.6-.6V4H5.086c-.525 0-.794-.6-.43-.96L7.56.174a.618.618 0 0 1 .86 0l2.9 2.866c.364.36.096.96-.43.96H9.01v6.4a.6.6 0 0 1-.6.6h-.8Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                          <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                            Share
                          </span>
                        </span>
                      </button>
                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                        <button
                          type="button"
                          aria-label="Show more"
                          data-nc="true"
                          data-testid="Header-ContextMenu"
                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                        >
                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                            <svg
                              height="16px"
                              width="16px"
                              viewBox="0 0 16 16"
                              role="img"
                              aria-label="DotsIcon"
                              className="sc-11y93t1-0 dqXaRM ui-icon"
                            >
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="header-secondary__Container-sc-wrzcoj-1 jjoxBj">
                    <div className="header-secondary__RelativeShift-sc-wrzcoj-0 iXlKLl">
                      <div className="header-secondary__ScrollableContainer-sc-wrzcoj-2 hdDHBa">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                          <button
                            type="button"
                            data-nc="true"
                            data-testid="ConfigurationDropdown-ItemConfigurationButton"
                            className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                          >
                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="TextListIcon"
                                className="sc-11y93t1-0 dqXaRM ui-icon"
                              >
                                <path
                                  d="M3 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6 4h8.999V2H6v2zm8.999 5H6V7h8.999v2zm0 5H6v-2h8.999v2zM4.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                            <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                              <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                Items: Features
                              </span>
                            </span>
                          </button>
                          <button
                            type="button"
                            data-nc="true"
                            data-testid="grouping-button"
                            className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                          >
                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="DuplicateIcon"
                                className="sc-11y93t1-0 dqXaRM ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M15 0H7c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 8H8V2h6v6zm-6 6H2V8h2V6H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-3H8v2z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                              <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                Grouped by: Customizable swimlanes
                              </span>
                            </span>
                          </button>
                          <div className="board-filter-wrapperstyled__BoardFilterWrapper-sc-texokw-0 cYrnhR">
                            <div className="sc-1i3qtnn-0 kxgOFp">
                              <div
                                data-testid="BoardFilter-Filters-Icon"
                                className="sc-1i3qtnn-1 hXSezE"
                              >
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    aria-label="Filter"
                                    data-nc="true"
                                    data-testid="filter-button"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                  >
                                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="FilterIcon"
                                        className="sc-11y93t1-0 dqXaRM ui-icon"
                                      >
                                        <path
                                          d="M15 1H1v2h14V1zm-3 4H4v2h8V5zM6 9h4v2H6V9zm3 4H7v2h2v-2z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>
                                    <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                      <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                        Filter
                                      </span>
                                    </span>
                                  </button>
                                </span>
                                <div className="vu1IPbL1H8l1P3jRxAIV">
                                  <div className="f5VSbGks1i8DxdDJ324f">
                                    <div
                                      className="T38TAHfZiSXZ3g792lHy QpwL7Zf7Rkfx5pd82gGz b9vFPwdzsj0M366THDp0"
                                      style={{ display: "none" }}
                                    >
                                      <span>+0</span>
                                      <div className="iTRjKj3YSDJ_uYHjNMJh pFc6ScbH9FPqyP6_nk1V" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 jJmdFf">
                          <button
                            type="button"
                            data-nc="true"
                            data-testid="ConfigureButton-Roadmap"
                            className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                          >
                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="FiltersIcon"
                                className="sc-11y93t1-0 dqXaRM ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M0 8h1v8h2V8h1V6.001H0V8zm3-8H1v4h2V0zm9 6.001V8h1.001v8h2V8H16V6.001h-4zM15.001 0h-2v4h2V0zm-9 12h1v4h2v-4h1v-2h-4v2zm3-12h-2v8h2V0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                              <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                Configure
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="box__StyledBox-sc-b30x7m-0 gsPlIB" />
                <div className="page-layout__Content-sc-1u3l193-0 dnCWBw">
                  <div
                    className="HWD9xbqoTl53EwPuYXpP"
                    data-testid="Roadmap-Container"
                  >
                    <div className="sc-1hm5n9z-0 fxlyxe">
                      <div
                        data-hotkeys-layer="true"
                        tabIndex={-1}
                        id="timeline-roadmap-canvas"
                        data-testid="timeline-roadmap-content"
                        className="sc-3lzs6w-0 hTixZK"
                      >
                        <div className="sc-3lzs6w-2 btpMtK" />
                        <div className="timeframe-coachmark-attachable-element__TimeframeCoachmarkAttachableElement-sc-o4xvpr-0 kJXROJ" />
                        <div
                          data-testid="StrategicRoadmapTimeline"
                          className="sc-3lzs6w-1 sc-3lzs6w-3 idsOyL ewDniv"
                        >
                          <div
                            className="sc-3lzs6w-4 kEeozm"
                            style={{
                              width: 2191,
                              transform: "translate3d(-729px, 0px, 0px)"
                            }}
                          >
                            <div className="sc-17nsz3k-0 jCpet">
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(-1px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fpHGmH"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 iSNHIG"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 jjxpeV"
                                  >
                                    2022
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(183px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fpHGmH"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 iSNHIG"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 jjxpeV"
                                  >
                                    2023
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(913px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fpHGmH"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 iSNHIG"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 jjxpeV"
                                  >
                                    2024
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1645px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fpHGmH"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 iSNHIG"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 jjxpeV"
                                  >
                                    2025
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(2189px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fpHGmH"
                                  style={{ height: 24 }}
                                />
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(-1px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q4
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(183px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q1
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(363px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q2
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(545px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q3
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(729px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q4
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(913px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q1
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1095px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q2
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1277px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q3
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1461px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q4
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1645px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q1
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(1825px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q2
                                  </span>
                                </div>
                              </div>
                              <div
                                data-testid="Timeline-Mark-Container"
                                className="sc-1uei8ux-0 gzyALH"
                                style={{
                                  transform: "translate3d(2007px, 0px, 0px)"
                                }}
                              >
                                <div
                                  className="sc-1uei8ux-1 fZVWUi"
                                  style={{ height: 24 }}
                                />
                                <div
                                  className="sc-1uei8ux-2 hANxhr"
                                  style={{ left: 24 }}
                                >
                                  <span
                                    data-testid="Timeline-Mark"
                                    className="sc-1uei8ux-3 gqqVvF"
                                  >
                                    Q3
                                  </span>
                                </div>
                              </div>
                              <div
                                width="2191.9999999537035"
                                className="sc-9s4gu6-0 cYdGWZ"
                              >
                                <div
                                  className="sc-9s4gu6-3 hLiSNV"
                                  style={{
                                    transform: "translate3d(779px, 0px, 0px)"
                                  }}
                                >
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <div className="sc-9s4gu6-5 ciFyfC" />
                                  </span>
                                </div>
                              </div>
                              <div
                                data-nc-deprecated="true"
                                className="sc-15oqhgw-0 btnsEY"
                                style={{
                                  transform: "translate3d(829px, 0px, 0px)"
                                }}
                              >
                                <div className="sc-15oqhgw-1 egvHQe" />
                              </div>
                            </div>
                          </div>
                          <div className="sc-t80pcj-0 fURYZt">
                            <div className="sc-t80pcj-1 bwwIwW" />
                            <span className="sc-t80pcj-2 gffxyM">Today</span>
                          </div>
                          <div className="sc-t80pcj-0 jFQTt">
                            <div className="sc-t80pcj-1 iFTBsT" />
                            <span className="sc-t80pcj-2 gffxyM">Today</span>
                          </div>
                        </div>
                        <div
                          data-testid="SwimlanesSidebar"
                          className="sc-159bwpq-0 cvEZYs"
                          style={{
                            transform: "translate3d(0px, 0px, 0px)",
                            bottom: 0
                          }}
                        >
                          <div
                            className="sc-11a79b7-1 hZOdIE"
                            style={{ transform: "translate3d(0px, 26px, 0px)" }}
                          >
                            <div className="sc-11a79b7-0 hIYqrs">
                              <div className="sc-1e779gn-0 eugxNz">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="AddSwimlane-Button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="PlusCircleIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      Swimlane
                                    </span>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc-noblgf-1 eUWIUw"
                          style={{ transform: "translate3d(0px, 0px, 0px)" }}
                        >
                          <div
                            className="sc-noblgf-0 FORaO"
                            style={{ transform: "translate3d(0px, 74px, 0px)" }}
                          />
                        </div>
                        <div
                          data-testid="StrategicRoadmapCanvas"
                          className="sc-3lzs6w-1 sc-3lzs6w-5 idsOyL fCBKrb"
                        >
                          <div
                            className="sc-3lzs6w-6 hyOgsk"
                            style={{
                              width: 2192,
                              height: 642,
                              transform: "translate3d(-729px, 0px, 0px)"
                            }}
                          >
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={-1}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{ transform: "translate3d(-1px, 0px, 0px)" }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={183}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(183px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={363}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(363px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={545}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(545px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={729}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(729px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={913}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(913px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={1095}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(1095px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={1277}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(1277px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={1461}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(1461px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={1645}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(1645px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={1825}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(1825px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVertical"
                              data-leftoffset={2007}
                              className="sc-yijmi1-0 sc-yijmi1-1 bZsxDa hAGaUK"
                              style={{
                                transform: "translate3d(2007px, 0px, 0px)"
                              }}
                            />
                            <div
                              data-testid="Timeline-CanvasLinesVerticalToday"
                              data-leftoffset={829}
                              className="sc-yijmi1-0 sc-yijmi1-2 bZsxDa dcnOlg"
                              style={{
                                transform: "translate3d(829px, 0px, 0px)"
                              }}
                            />
                            <div className="sc-eljxsz-0 djFHkw" />
                            <div
                              className="sc-f903t-0 OZrjh"
                              style={{
                                transform: "translate3d(0px, 122px, 0px)"
                              }}
                            >
                              <div
                                data-testid="Timeline-DraggableCard-Container"
                                className="sc-f903t-1 dQEkUm"
                                style={{
                                  transform: "translate3d(729px, 0px, 0px)",
                                  width: 184,
                                  height: 72
                                }}
                              >
                                <div className="sc-f903t-2 fNdgpz">
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleLeft"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: 0, right: "auto" }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleRight"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: "auto", right: 0 }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableContent"
                                    className="sc-f903t-3 gCcDBd"
                                  >
                                    <div className="sc-115hy16-0 huqRSG">
                                      <div className="sc-115hy16-1 hlzzKY">
                                        <div
                                          data-testid="Timeline-Card-Overflow"
                                          className="sc-pynneb-0 fwyoKe"
                                          style={{ width: 177 }}
                                        >
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <div className="sc-115hy16-4 sc-pynneb-1 eKCweU ddKlxq" />
                                        </div>
                                        <div
                                          data-testid="CanvasCardWrapper-Card"
                                          className="sc-115hy16-2 giNumB"
                                          style={{
                                            width: 184,
                                            transform:
                                              "translate3d(0px, 0px, 0px)",
                                            paddingLeft: 4,
                                            paddingRight: 3
                                          }}
                                        >
                                          <div data-testid="Card-visible">
                                            <div className="sc-ytv6aa-0 sigNo">
                                              <div className="sc-ytv6aa-1 jkPsdM">
                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                  <div
                                                    data-testid="Timeline-Card-Progress"
                                                    className="sc-1c36vzj-0 fpwkJE"
                                                  >
                                                    <div
                                                      data-testid="Timeline-Card-ProgressBar"
                                                      className="sc-1c36vzj-2 jLLSqT"
                                                      style={{ width: "0%" }}
                                                    />
                                                    <div
                                                      className="sc-1c36vzj-3 kLoBCo"
                                                      style={{ left: "0%" }}
                                                    />
                                                  </div>
                                                </span>
                                                <div className="sc-ytv6aa-2 jaZyYX">
                                                  <div className="sc-ytv6aa-3 bFLrjt">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                    <div className="sc-ytv6aa-5 fKdhFU">
                                                      <div className="sc-ytv6aa-6 hZmAVv">
                                                        <div className="sc-1p0ebqd-0 bJvbAB">
                                                          <div className="l306g84_3PfGluK5_5Vx">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <svg
                                                                viewBox="0 0 16 16"
                                                                className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                                data-testid="FeatureIcon-feature"
                                                              >
                                                                <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                              </svg>
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="sc-ytv6aa-9 bTnhJQ" />
                                                      <div className="sc-ytv6aa-7 fnSbAO">
                                                        <div className="sc-1ukbbuy-0 jOjzAQ">
                                                          <a
                                                            draggable="false"
                                                            id={24723141}
                                                            className=""
                                                            href="/roadmap/7450412-feature-launch-roadmap-sample/features/24723141/detail"
                                                          >
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <span
                                                                data-testid="Timeline-CardTitle-Label"
                                                                className="sc-1ukbbuy-1 izAnOp"
                                                              >
                                                                Sample feature 1
                                                              </span>
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <span
                                                          data-testid="Timeline-AddNewFeature-Icon"
                                                          className="sc-1uo2bsa-0 ktqPYu"
                                                        >
                                                          <span className="sc-1uo2bsa-1 csGlRS">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusCircleIcon"
                                                              className="sc-11y93t1-0 xIpMQ ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <div
                                                        data-testid="Timeline-CanvasCardFeaturesList-Actions"
                                                        className="sc-vcagm8-0 UUBmu"
                                                      >
                                                        <div
                                                          data-testid="Timeline-CardActions-Icon"
                                                          className="sc-vcagm8-1 fRhliE"
                                                        >
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-10 eMdbQJ" />
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="sc-ytv6aa-4 kYuDe">
                                                    <div
                                                      className="sc-zgquvj-3 fhkQkQ"
                                                      style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0
                                                      }}
                                                    >
                                                      <div className="sc-zgquvj-4 fPMyNK">
                                                        <div className="sc-zgquvj-5 dDOPdi" />
                                                        <div className="sc-zgquvj-5 RKeFg">
                                                          <div className="sc-zgquvj-6 klZhhT">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="Timeline-FeatureCardAttributeRow-Effort"
                                                                className="sc-bnhvlp-0 GthgH"
                                                              >
                                                                <svg
                                                                  height="12px"
                                                                  width="12px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="EffortIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M6.999 8.999V4h2v2.999h1.999v2H6.999zm1-6.999a5.999 5.999 0 1 0 0 11.998A6 6 0 0 0 7.999 2zm0 13.998A7.999 7.999 0 0 1 0 7.999 7.999 7.999 0 0 1 7.999 0a7.999 7.999 0 0 1 7.999 7.999 7.999 7.999 0 0 1-7.999 7.999z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                                <span className="sc-bnhvlp-1 dFLeUf">
                                                                  <span
                                                                    data-nc="true"
                                                                    className="textstyled__StyledText-sc-cx1866-0 fFABpb"
                                                                  >
                                                                    5
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bTnhJQ" />
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="CardAttribute-Comments"
                                                                className="sc-1o2u1wc-0 kzJVGm"
                                                              >
                                                                <svg
                                                                  height="16px"
                                                                  width="16px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="CommentIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M3.069 12H3v3.999L7.5 13h2A6.5 6.5 0 0 0 9.5.001h-3A6.5 6.5 0 0 0 0 6.5c.001 2.326 1.233 4.352 3.069 5.5zM6.5 2.001h3A4.5 4.5 0 0 1 9.5 11h-2L5 12.5v-1.775c-1.744-.62-3-2.268-3-4.225a4.5 4.5 0 0 1 4.5-4.499z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <div data-testid="Timeline-FeatureCardAttributeRow-Owner">
                                                              <div
                                                                data-nc="true"
                                                                className="avatar-primitivestyled__Container-sc-1bx7ono-0 bSwSNV"
                                                              >
                                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                                  <div className="avatar-primitivestyled__Wrapper-sc-1bx7ono-1 hjdAVk">
                                                                    <div className="avatar-primitivestyled__Mask-sc-1bx7ono-5 cigJeP">
                                                                      <div className="avatar-primitivestyled__Content-sc-1bx7ono-2 btKcPp">
                                                                        <div className="avatar-primitivestyled__ImageWrapper-sc-1bx7ono-4 gnyQMd">
                                                                          <img
                                                                            src="https://www.gravatar.com/avatar/c8836721209a210a9e10969bbfa9bec1?s=24&d=404"
                                                                            alt="Rakesh Goyal avatar"
                                                                            loading="lazy"
                                                                            decoding="async"
                                                                            height="100%"
                                                                            width="100%"
                                                                            data-nc="true"
                                                                            className="image__ResponsiveImage-sc-4gu1yy-0 bgZoMb"
                                                                          />
                                                                        </div>
                                                                        <div className="avatar-initialsstyled__Initials-sc-mzeca6-0 clWFRU">
                                                                          <span
                                                                            data-nc="true"
                                                                            className="textstyled__StyledText-sc-cx1866-0 eALGil"
                                                                          >
                                                                            RG
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="sc-115hy16-4 eKCweU" />
                                        </div>
                                      </div>
                                      <div
                                        className="sc-115hy16-3 gzWwtM"
                                        style={{ height: 72, inset: "0px 4px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="sc-f903t-0 OZrjh"
                              style={{ transform: "translate3d(0px, 38px, 0px)" }}
                            >
                              <div
                                data-testid="Timeline-DraggableCard-Container"
                                className="sc-f903t-1 dQEkUm"
                                style={{
                                  transform: "translate3d(1095px, 0px, 0px)",
                                  width: 182,
                                  height: 72
                                }}
                              >
                                <div className="sc-f903t-2 fNdgpz">
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleLeft"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: 0, right: "auto" }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleRight"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: "auto", right: 0 }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableContent"
                                    className="sc-f903t-3 gCcDBd"
                                  >
                                    <div className="sc-115hy16-0 huqRSG">
                                      <div className="sc-115hy16-1 hlzzKY">
                                        <div
                                          data-testid="Timeline-Card-Overflow"
                                          className="sc-pynneb-0 fwyoKe"
                                          style={{ width: 175 }}
                                        >
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <div className="sc-115hy16-4 sc-pynneb-1 eKCweU ddKlxq" />
                                        </div>
                                        <div
                                          data-testid="CanvasCardWrapper-Card"
                                          className="sc-115hy16-2 giNumB"
                                          style={{
                                            width: 182,
                                            transform:
                                              "translate3d(0px, 0px, 0px)",
                                            paddingLeft: 4,
                                            paddingRight: 3
                                          }}
                                        >
                                          <div data-testid="Card-visible">
                                            <div className="sc-ytv6aa-0 sigNo">
                                              <div className="sc-ytv6aa-1 jkPsdM">
                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                  <div
                                                    data-testid="Timeline-Card-Progress"
                                                    className="sc-1c36vzj-0 fpwkJE"
                                                  >
                                                    <div
                                                      data-testid="Timeline-Card-ProgressBar"
                                                      className="sc-1c36vzj-2 jLLSqT"
                                                      style={{ width: "0%" }}
                                                    />
                                                    <div
                                                      className="sc-1c36vzj-3 kLoBCo"
                                                      style={{ left: "0%" }}
                                                    />
                                                  </div>
                                                </span>
                                                <div className="sc-ytv6aa-2 jaZyYX">
                                                  <div className="sc-ytv6aa-3 bFLrjt">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                    <div className="sc-ytv6aa-5 fKdhFU">
                                                      <div className="sc-ytv6aa-6 hZmAVv">
                                                        <div className="sc-1p0ebqd-0 bJvbAB">
                                                          <div className="l306g84_3PfGluK5_5Vx">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <svg
                                                                viewBox="0 0 16 16"
                                                                className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                                data-testid="FeatureIcon-feature"
                                                              >
                                                                <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                              </svg>
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="sc-ytv6aa-9 bTnhJQ" />
                                                      <div className="sc-ytv6aa-7 fnSbAO">
                                                        <div className="sc-1ukbbuy-0 jOjzAQ">
                                                          <a
                                                            draggable="false"
                                                            id={24723142}
                                                            className=""
                                                            href="/roadmap/7450412-feature-launch-roadmap-sample/features/24723142/detail"
                                                          >
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <span
                                                                data-testid="Timeline-CardTitle-Label"
                                                                className="sc-1ukbbuy-1 izAnOp"
                                                              >
                                                                Sample feature 2
                                                              </span>
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <span
                                                          data-testid="Timeline-AddNewFeature-Icon"
                                                          className="sc-1uo2bsa-0 ktqPYu"
                                                        >
                                                          <span className="sc-1uo2bsa-1 csGlRS">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusCircleIcon"
                                                              className="sc-11y93t1-0 xIpMQ ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <div
                                                        data-testid="Timeline-CanvasCardFeaturesList-Actions"
                                                        className="sc-vcagm8-0 UUBmu"
                                                      >
                                                        <div
                                                          data-testid="Timeline-CardActions-Icon"
                                                          className="sc-vcagm8-1 fRhliE"
                                                        >
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-10 eMdbQJ" />
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="sc-ytv6aa-4 kYuDe">
                                                    <div
                                                      className="sc-zgquvj-3 fhkQkQ"
                                                      style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0
                                                      }}
                                                    >
                                                      <div className="sc-zgquvj-4 fPMyNK">
                                                        <div className="sc-zgquvj-5 dDOPdi" />
                                                        <div className="sc-zgquvj-5 RKeFg">
                                                          <div className="sc-zgquvj-6 klZhhT">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="Timeline-FeatureCardAttributeRow-Effort"
                                                                className="sc-bnhvlp-0 GthgH"
                                                              >
                                                                <svg
                                                                  height="12px"
                                                                  width="12px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="EffortIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M6.999 8.999V4h2v2.999h1.999v2H6.999zm1-6.999a5.999 5.999 0 1 0 0 11.998A6 6 0 0 0 7.999 2zm0 13.998A7.999 7.999 0 0 1 0 7.999 7.999 7.999 0 0 1 7.999 0a7.999 7.999 0 0 1 7.999 7.999 7.999 7.999 0 0 1-7.999 7.999z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                                <span className="sc-bnhvlp-1 dFLeUf">
                                                                  <span
                                                                    data-nc="true"
                                                                    className="textstyled__StyledText-sc-cx1866-0 fFABpb"
                                                                  >
                                                                    1
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bTnhJQ" />
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="CardAttribute-Comments"
                                                                className="sc-1o2u1wc-0 kzJVGm"
                                                              >
                                                                <svg
                                                                  height="16px"
                                                                  width="16px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="CommentIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M3.069 12H3v3.999L7.5 13h2A6.5 6.5 0 0 0 9.5.001h-3A6.5 6.5 0 0 0 0 6.5c.001 2.326 1.233 4.352 3.069 5.5zM6.5 2.001h3A4.5 4.5 0 0 1 9.5 11h-2L5 12.5v-1.775c-1.744-.62-3-2.268-3-4.225a4.5 4.5 0 0 1 4.5-4.499z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <div data-testid="Timeline-FeatureCardAttributeRow-Owner">
                                                              <div
                                                                data-nc="true"
                                                                className="avatar-primitivestyled__Container-sc-1bx7ono-0 bSwSNV"
                                                              >
                                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                                  <div className="avatar-primitivestyled__Wrapper-sc-1bx7ono-1 hjdAVk">
                                                                    <div className="avatar-primitivestyled__Mask-sc-1bx7ono-5 cigJeP">
                                                                      <div className="avatar-primitivestyled__Content-sc-1bx7ono-2 btKcPp">
                                                                        <div className="avatar-primitivestyled__ImageWrapper-sc-1bx7ono-4 gnyQMd">
                                                                          <img
                                                                            src="https://www.gravatar.com/avatar/c8836721209a210a9e10969bbfa9bec1?s=24&d=404"
                                                                            alt="Rakesh Goyal avatar"
                                                                            loading="lazy"
                                                                            decoding="async"
                                                                            height="100%"
                                                                            width="100%"
                                                                            data-nc="true"
                                                                            className="image__ResponsiveImage-sc-4gu1yy-0 bgZoMb"
                                                                          />
                                                                        </div>
                                                                        <div className="avatar-initialsstyled__Initials-sc-mzeca6-0 clWFRU">
                                                                          <span
                                                                            data-nc="true"
                                                                            className="textstyled__StyledText-sc-cx1866-0 eALGil"
                                                                          >
                                                                            RG
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="sc-115hy16-4 eKCweU" />
                                        </div>
                                      </div>
                                      <div
                                        className="sc-115hy16-3 gzWwtM"
                                        style={{ height: 72, inset: "0px 4px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="sc-f903t-0 OZrjh"
                              style={{ transform: "translate3d(0px, 38px, 0px)" }}
                            >
                              <div
                                data-testid="Timeline-DraggableCard-Container"
                                className="sc-f903t-1 dQEkUm"
                                style={{
                                  transform: "translate3d(729px, 0px, 0px)",
                                  width: 184,
                                  height: 72
                                }}
                              >
                                <div className="sc-f903t-2 fNdgpz">
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleLeft"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: 0, right: "auto" }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableCard-HandleRight"
                                    className="sc-x7qbks-0 ToFdb"
                                    style={{ top: 0, left: "auto", right: 0 }}
                                  >
                                    <div className="sc-x7qbks-1 bYGMOh" />
                                    <span className="sc-x7qbks-2 gZbnPl" />
                                  </div>
                                  <div
                                    data-testid="Timeline-DraggableContent"
                                    className="sc-f903t-3 gCcDBd"
                                  >
                                    <div className="sc-115hy16-0 huqRSG">
                                      <div className="sc-115hy16-1 hlzzKY">
                                        <div
                                          data-testid="Timeline-Card-Overflow"
                                          className="sc-pynneb-0 fwyoKe"
                                          style={{ width: 177 }}
                                        >
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="overlap-sidestyled__OverlapSide-sc-1bsbxcn-0 ORhNR" />
                                          </span>
                                          <div className="sc-115hy16-4 sc-pynneb-1 eKCweU ddKlxq" />
                                        </div>
                                        <div
                                          data-testid="CanvasCardWrapper-Card"
                                          className="sc-115hy16-2 giNumB"
                                          style={{
                                            width: 184,
                                            transform:
                                              "translate3d(0px, 0px, 0px)",
                                            paddingLeft: 4,
                                            paddingRight: 3
                                          }}
                                        >
                                          <div data-testid="Card-visible">
                                            <div className="sc-ytv6aa-0 sigNo">
                                              <div className="sc-ytv6aa-1 jkPsdM">
                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                  <div
                                                    data-testid="Timeline-Card-Progress"
                                                    className="sc-1c36vzj-0 fpwkJE"
                                                  >
                                                    <div
                                                      data-testid="Timeline-Card-ProgressBar"
                                                      className="sc-1c36vzj-2 jLLSqT"
                                                      style={{ width: "0%" }}
                                                    />
                                                    <div
                                                      className="sc-1c36vzj-3 kLoBCo"
                                                      style={{ left: "0%" }}
                                                    />
                                                  </div>
                                                </span>
                                                <div className="sc-ytv6aa-2 jaZyYX">
                                                  <div className="sc-ytv6aa-3 bFLrjt">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                    <div className="sc-ytv6aa-5 fKdhFU">
                                                      <div className="sc-ytv6aa-6 hZmAVv">
                                                        <div className="sc-1p0ebqd-0 bJvbAB">
                                                          <div className="l306g84_3PfGluK5_5Vx">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <svg
                                                                viewBox="0 0 16 16"
                                                                className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                                data-testid="FeatureIcon-feature"
                                                              >
                                                                <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                              </svg>
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="sc-ytv6aa-9 bTnhJQ" />
                                                      <div className="sc-ytv6aa-7 fnSbAO">
                                                        <div className="sc-1ukbbuy-0 jOjzAQ">
                                                          <a
                                                            draggable="false"
                                                            id={24723143}
                                                            className=""
                                                            href="/roadmap/7450412-feature-launch-roadmap-sample/features/24723143/detail"
                                                          >
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <span
                                                                data-testid="Timeline-CardTitle-Label"
                                                                className="sc-1ukbbuy-1 izAnOp"
                                                              >
                                                                Sample feature 3
                                                              </span>
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <span
                                                          data-testid="Timeline-AddNewFeature-Icon"
                                                          className="sc-1uo2bsa-0 ktqPYu"
                                                        >
                                                          <span className="sc-1uo2bsa-1 csGlRS">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="PlusCircleIcon"
                                                              className="sc-11y93t1-0 xIpMQ ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ">
                                                      <div
                                                        data-testid="Timeline-CanvasCardFeaturesList-Actions"
                                                        className="sc-vcagm8-0 UUBmu"
                                                      >
                                                        <div
                                                          data-testid="Timeline-CardActions-Icon"
                                                          className="sc-vcagm8-1 fRhliE"
                                                        >
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="DotsIcon"
                                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-9 bTnhJQ" />
                                                    <div className="sc-ytv6aa-10 eMdbQJ" />
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        minWidth: 0,
                                                        minHeight: 1
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="sc-ytv6aa-4 kYuDe">
                                                    <div
                                                      className="sc-zgquvj-3 fhkQkQ"
                                                      style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0
                                                      }}
                                                    >
                                                      <div className="sc-zgquvj-4 fPMyNK">
                                                        <div className="sc-zgquvj-5 dDOPdi" />
                                                        <div className="sc-zgquvj-5 RKeFg">
                                                          <div className="sc-zgquvj-6 klZhhT">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="Timeline-FeatureCardAttributeRow-Effort"
                                                                className="sc-bnhvlp-0 GthgH"
                                                              >
                                                                <svg
                                                                  height="12px"
                                                                  width="12px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="EffortIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M6.999 8.999V4h2v2.999h1.999v2H6.999zm1-6.999a5.999 5.999 0 1 0 0 11.998A6 6 0 0 0 7.999 2zm0 13.998A7.999 7.999 0 0 1 0 7.999 7.999 7.999 0 0 1 7.999 0a7.999 7.999 0 0 1 7.999 7.999 7.999 7.999 0 0 1-7.999 7.999z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                                <span className="sc-bnhvlp-1 dFLeUf">
                                                                  <span
                                                                    data-nc="true"
                                                                    className="textstyled__StyledText-sc-cx1866-0 fFABpb"
                                                                  >
                                                                    3
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bTnhJQ" />
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                              <div
                                                                data-testid="CardAttribute-Comments"
                                                                className="sc-1o2u1wc-0 kzJVGm"
                                                              >
                                                                <svg
                                                                  height="16px"
                                                                  width="16px"
                                                                  viewBox="0 0 16 16"
                                                                  role="img"
                                                                  aria-label="CommentIcon"
                                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                                >
                                                                  <path
                                                                    fill="currentColor"
                                                                    fillRule="evenodd"
                                                                    d="M3.069 12H3v3.999L7.5 13h2A6.5 6.5 0 0 0 9.5.001h-3A6.5 6.5 0 0 0 0 6.5c.001 2.326 1.233 4.352 3.069 5.5zM6.5 2.001h3A4.5 4.5 0 0 1 9.5 11h-2L5 12.5v-1.775c-1.744-.62-3-2.268-3-4.225a4.5 4.5 0 0 1 4.5-4.499z"
                                                                    clipRule="evenodd"
                                                                  />
                                                                </svg>
                                                              </div>
                                                            </span>
                                                          </div>
                                                          <div className="sc-ytv6aa-9 bVqNxJ">
                                                            <div data-testid="Timeline-FeatureCardAttributeRow-Owner">
                                                              <div
                                                                data-nc="true"
                                                                className="avatar-primitivestyled__Container-sc-1bx7ono-0 bSwSNV"
                                                              >
                                                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                                  <div className="avatar-primitivestyled__Wrapper-sc-1bx7ono-1 hjdAVk">
                                                                    <div className="avatar-primitivestyled__Mask-sc-1bx7ono-5 cigJeP">
                                                                      <div className="avatar-primitivestyled__Content-sc-1bx7ono-2 btKcPp">
                                                                        <div className="avatar-primitivestyled__ImageWrapper-sc-1bx7ono-4 gnyQMd">
                                                                          <img
                                                                            src="https://www.gravatar.com/avatar/c8836721209a210a9e10969bbfa9bec1?s=24&d=404"
                                                                            alt="Rakesh Goyal avatar"
                                                                            loading="lazy"
                                                                            decoding="async"
                                                                            height="100%"
                                                                            width="100%"
                                                                            data-nc="true"
                                                                            className="image__ResponsiveImage-sc-4gu1yy-0 bgZoMb"
                                                                          />
                                                                        </div>
                                                                        <div className="avatar-initialsstyled__Initials-sc-mzeca6-0 clWFRU">
                                                                          <span
                                                                            data-nc="true"
                                                                            className="textstyled__StyledText-sc-cx1866-0 eALGil"
                                                                          >
                                                                            RG
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="sc-115hy16-4 eKCweU" />
                                        </div>
                                      </div>
                                      <div
                                        className="sc-115hy16-3 gzWwtM"
                                        style={{ height: 72, inset: "0px 4px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="sc-ccws65-0 bUNUDn" />
                          </div>
                        </div>
                        <div className="sc-1c8142r-0 iFtRuU">
                          <div
                            width={825}
                            className="sc-1bb7bwa-0 dXpYvC"
                            style={{ width: 825 }}
                          >
                            <div className="sc-1bb7bwa-1 cEFKgc">
                              <div
                                className="sc-1bb7bwa-2 iZnnzB"
                                style={{ left: "272.707px", width: "37.4084%" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="sc-1c8142r-1 eqsenz" />
                      </div>
                      <div
                        className="ylTMo5EH3cF8l80h46UG"
                        data-testid="StrategicRoadmap-FloatingButton"
                      >
                        <div>
                          <div className="floating-actionstyled__StyledWrapper-sc-4rigmj-1 jrhhRX">
                            <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 OfgtE">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 eFtOQb"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="PlusIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                            <div className="floating-actionstyled__StyledMenu-sc-4rigmj-0 jPywQO">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 kxzJUm" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="YPhjEfZFRZNuqGKZkVg4" data-testid="Sidebar-Menu" />
            <div className="sc-1rpu86o-0 htHaxy">
              <div id="floating-actions" className="sc-1rpu86o-1 dQtPHH">
                <div className="canvas-scale__Wrapper-sc-1hlh8bi-0 eIzUGc">
                  <div className="canvas-scale-buttonstyled__Wrapper-sc-iyj229-0 gpMhYE">
                    <button
                      type="button"
                      aria-label="Zoom out"
                      data-nc="true"
                      className="button-primitive__StyledButton-sc-1guvopt-0 edcyTz"
                    >
                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="MinusIcon"
                          className="sc-11y93t1-0 dqXaRM ui-icon"
                        >
                          <path
                            fill="currentColor"
                            d="M2 8a1 1 0 0 1 1-1h10.001a.999.999 0 1 1 0 2H3a1 1 0 0 1-1-1z"
                          />
                        </svg>
                      </div>
                    </button>
                    <button
                      type="button"
                      className="canvas-scale-buttonstyled__Button-sc-iyj229-1 eazIkS"
                    >
                      <span
                        data-nc="true"
                        className="textstyled__StyledText-sc-cx1866-0 dmAImT"
                      >
                        100%
                      </span>
                    </button>
                    <button
                      type="button"
                      aria-label="Zoom in"
                      data-nc="true"
                      className="button-primitive__StyledButton-sc-1guvopt-0 edcyTz"
                    >
                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="PlusIcon"
                          className="sc-11y93t1-0 dqXaRM ui-icon"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>
                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                  <button
                    type="button"
                    aria-label="Presentation mode"
                    data-nc="true"
                    className="button-primitive__StyledButton-sc-1guvopt-0 edcyTz"
                  >
                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                      <svg
                        height="16px"
                        width="16px"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="ExpandToModalIcon"
                        className="sc-11y93t1-0 dqXaRM ui-icon"
                      >
                        <path
                          d="M13.004 4.676 9.517 8 8.003 6.486 11.328 3H8V1h7.003v6.998h-1.999V4.676zM3 11.324 6.485 8 8 9.514 4.676 13h3.327v2H1V8.002h2v3.322z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </button>
                </span>
                <div>
                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                    <button
                      type="button"
                      aria-label="Legend"
                      data-nc="true"
                      data-testid="ColorsLegendButton"
                      className="button-primitive__StyledButton-sc-1guvopt-0 biThvo"
                    >
                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="ColorCodingIcon"
                          className="sc-11y93t1-0 dqXaRM ui-icon"
                        >
                          <circle cx="4.5" cy="4.5" r="2.5" fill="#2693FF" />
                          <circle cx="11.5" cy="4.5" r="2.5" fill="#FFC600" />
                          <path
                            fill="#FF4747"
                            d="M7 11.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
                          />
                          <circle cx="11.5" cy="11.5" r="2.5" fill="#BC80F9" />
                        </svg>
                      </div>
                    </button>
                  </span>
                </div>
              </div>
              <div className="sc-1rpu86o-2 keUbDp">
                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                  <a data-testid="HelpMenu-Button" className="sc-ya26g2-1 jfftCp">
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="QuestionMarkIcon"
                      className="sc-11y93t1-0 jMzzJy ui-icon"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.88 11.67h2.357V14H6.88v-2.33ZM5.57 2.613C6.193 2.204 6.954 2 7.859 2c1.189 0 2.175.29 2.962.87.785.58 1.18 1.44 1.18 2.579 0 .699-.17 1.287-.512 1.765-.201.29-.582.66-1.15 1.113l-.556.444c-.305.24-.508.523-.606.845-.063.204-.099.521-.104.95H6.934c.031-.907.116-1.534.253-1.88.136-.347.487-.746 1.054-1.197l.575-.46c.188-.145.34-.304.455-.475.21-.297.314-.621.314-.977 0-.407-.117-.78-.35-1.115-.232-.337-.66-.504-1.278-.504-.609 0-1.04.207-1.296.62a2.432 2.432 0 0 0-.381 1.29H4c.063-1.531.587-2.617 1.57-3.256Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div id="popup" />
          <div id="deprecated_tooltip" />
          <div id="tooltip" />
          <div id="snippet-popup-portal" />
          <div id="helper-portal" />
          <div id="dropdown-portal" />
          <div id="modal-portal" />
          <div id="portal-card-detail" />
          <div id="onboarding_tooltip" />
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          zIndex: 7000002,
          inset: 16,
          pointerEvents: "none"
        }}
      />
    </section>
    <iframe
      data-product="web_widget"
      title="No content"
      role="presentation"
      tabIndex={-1}
      allow="microphone *"
      aria-hidden="true"
      src="about:blank"
      style={{
        width: 0,
        height: 0,
        border: 0,
        position: "absolute",
        top: "-9999px"
      }}
    />
    <div
      id="batBeacon685656893368"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    >
      <img
        id="batBeacon962604951868"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&pi=918639831&lg=en-US&sw=1512&sh=982&sc=30&tl=Productboard&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&r=&lt=534&evt=pageLoad&sv=1&rn=341269"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon255391326980"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20javascript&el2=User%20load%20javascript&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=174783"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon380054000954"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20all%20perf&el2=User%20load%20all%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=851702"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon83614373139"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Smarter%20json%20mvb%20data%20loaded&el2=Smarter%20json%20mvb%20data%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=485852"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon49348131027"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20shell%20loaded&el2=App%20shell%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=962333"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon944048896834"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20loaded%20all%20smarter%20json%20data&el2=App%20loaded%20all%20smarter%20json%20data&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=624574"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon590123264838"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20perf&el2=User%20load%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=217919"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon624307769589"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Mvb%20rendered&el2=Mvb%20rendered&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=937830"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon369335872118"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Roadmap%20board%20viewed&el2=Roadmap%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=337830"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon254759609399"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=232074"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
      <img
        id="batBeacon138443604070"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=b6c8a9b4-ab4e-4ba7-9133-d539bd1cc49f&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=405260"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
    </div>
    <iframe
      id="intercom-frame"
      style={{
        position: "absolute !important",
        opacity: "0 !important",
        width: "1px !important",
        height: "1px !important",
        top: "0 !important",
        left: "0 !important",
        border: "none !important",
        display: "block !important",
        zIndex: "-1 !important",
        pointerEvents: "none"
      }}
      aria-hidden="true"
      tabIndex={-1}
      title="Intercom"
    />
    <div>
      <iframe
        title="Opens a widget where you can chat to one of our agents"
        id="launcher"
        tabIndex={0}
        style={{
          colorScheme: "light",
          width: 0,
          height: 50,
          padding: 0,
          margin: "10px 20px",
          position: "fixed",
          bottom: 0,
          overflow: "visible",
          opacity: 1,
          border: 0,
          zIndex: 999998,
          transitionDuration: "250ms",
          transitionTimingFunction: "cubic-bezier(0.645, 0.045, 0.355, 1)",
          transitionProperty: "opacity, top, bottom",
          right: 0
        }}
      />
    </div>
    <div id="DndDescribedBy-0" style={{ display: "none" }}>
      To pick up a draggable item, press the space bar. While dragging, use the
      arrow keys to move the item. Press space again to drop the item in its new
      position, or press escape to cancel.
    </div>
    <div
      id="DndLiveRegion-0"
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: 1,
        height: 1,
        margin: "-1px",
        border: 0,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0px, 0px, 0px, 0px)",
        clipPath: "inset(100%)",
        whiteSpace: "nowrap"
      }}
    />
    <div id="DndDescribedBy-1" style={{ display: "none" }}>
      To pick up a draggable item, press the space bar. While dragging, use the
      arrow keys to move the item. Press space again to drop the item in its new
      position, or press escape to cancel.
    </div>
    <div
      id="DndLiveRegion-1"
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: 1,
        height: 1,
        margin: "-1px",
        border: 0,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0px, 0px, 0px, 0px)",
        clipPath: "inset(100%)",
        whiteSpace: "nowrap"
      }}
    />
    <iframe
      name="__privateStripeMetricsController6140"
      frameBorder={0}
      allowTransparency="true"
      scrolling="no"
      role="presentation"
      allow="payment *"
      src="https://js.stripe.com/v3/m-outer-27c67c0d52761104439bb051c7856ab1.html#url=https%3A%2F%2Fvelt.productboard.com&title=Feature%20launch%20roadmap%20(sample)%20%7C%20Productboard&referrer=&muid=99400dc8-947a-4e4a-9489-8682ef4f957bb38a6d&sid=NA&version=6&preview=false&metaReferrerPolicy=origin"
      aria-hidden="true"
      tabIndex={-1}
      style={{
        border: "none !important",
        margin: "0px !important",
        padding: "0px !important",
        width: "1px !important",
        minWidth: "100% !important",
        overflow: "hidden !important",
        display: "block !important",
        visibility: "hidden !important",
        position: "fixed !important",
        height: "1px !important",
        pointerEvents: "none !important",
        userSelect: "none !important"
      }}
    />
    <div className="intercom-lightweight-app" />
    <div id="rvNiWyVRbzxC" style={{ display: "none" }} />
  </>
  )
}
